module.exports = __webpack_public_path__ + "static/img/AG.e6bede01.png";